import { render, staticRenderFns } from "./ControlActionHistories.v2.vue?vue&type=template&id=82e849fc&scoped=true&"
import script from "./ControlActionHistories.v2.vue?vue&type=script&lang=js&"
export * from "./ControlActionHistories.v2.vue?vue&type=script&lang=js&"
import style0 from "./ControlActionHistories.v2.vue?vue&type=style&index=0&id=82e849fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e849fc",
  null
  
)

export default component.exports